import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { de } from './de';
import { en } from './en';
import { es } from './es';
import { fi } from './fi';
import { fr } from './fr';
import { hu } from './hu';
import { it } from './it';
import { ja } from './ja';
import { ko } from './ko';
import { nl } from './nl';
import { pl } from './pl';
import { pt } from './pt-br';
import { sk } from './sk';
import { sv } from './sv';

export const defaultNS = 'common';

export const resources = {
  'en-US': en,
  'de-DE': de,
  'es-ES': es,
  'pt-BR': pt,
  'it-IT': it,
  'fr-FR': fr,
  'ja-JP': ja,
  'ko-KR': ko,
  'nl-NL': nl,
  'fi-FI': fi,
  'hu-HU': hu,
  'pl-PL': pl,
  'sk-SK': sk,
  'sv-SE': sv,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: {
      default: ['en-US'],
    },
    supportedLngs: [
      'en-US',
      'de-DE',
      'es-ES',
      'pt-BR',
      'it-IT',
      'fr-FR',
      'ja-JP',
      'ko-KR',
      'nl-NL',
      'fi-FI',
      'hu-HU',
      'pl-PL',
      'sk-SK',
      'sv-SE',
    ],
    interpolation: {
      escapeValue: false,
    },
    defaultNS,
  });
